export default "__VITE_ASSET__DogZ$jat__"